module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    ref: "readImageList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "dynamicOperationName": _vm.dynamicOperationName,
      "highlight-current-row": "",
      "height": _vm.height
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "current-change": _vm.handleCurrentChange
    }
  }, [(_vm.showCheck) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "26"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.head), function(item) {
    return ((item.props == 'reportEvidences' || item.props == 'reportConclusion') ? false : true) ? _c('el-table-column', {
      attrs: {
        "show-overflow-tooltip": _vm.show,
        "prop": item.props,
        "width": item.columnWidth,
        "label": item.label,
        "min-width": item.width
      }
    }) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-9cfa49f6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tables/reportTable.vue
// module id = 591
// module chunks = 1 2 3 4 5 6 7 8